<r2e-logo [variant]="logoVariant()" />

<h1>
  <span>{{ 'AUTH.SIGN_UP.TITLE' | translate }}</span>
  {{ 'AUTH.SIGN_UP.SUBTITLE' | translate }}
</h1>

<form [formGroup]="signUpForm" (ngSubmit)="signUp()">
  <div class="form-field">
    <label for="full-name">{{ 'COMMON.LABELS.FULL_NAME' | translate }}*</label>
    <input formControlName="fullName" id="full-name" type="text">
    <span class="hint">*{{ 'COMMON.HINTS.REQUIRED' | translate }}</span>
    <span class="error" *r2eValidationError="let errorMessage from signUpForm.controls.fullName.errors">{{ errorMessage }}</span>
  </div>

  <div class="form-field">
    <label for="email">{{ 'COMMON.LABELS.EMAIL' | translate }}*</label>
    <input formControlName="email" id="email" type="email">
    <span class="hint">*{{ 'COMMON.HINTS.REQUIRED' | translate }}</span>
    <span class="error" *r2eValidationError="let errorMessage from signUpForm.controls.email.errors">{{ errorMessage }}</span>
  </div>

  <div class="form-field">
    <label for="password">{{ 'COMMON.LABELS.PASSWORD' | translate }}*</label>
    <input formControlName="password" id="password" [type]="passwordHidden() ? 'password' : 'text'">
    <button mat-icon-button type="button" (click)="togglePasswordVisibility()">
      <mat-icon>{{ passwordHidden() ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <span class="hint">*{{ 'COMMON.HINTS.REQUIRED' | translate }}</span>
    <span class="error" *r2eValidationError="let errorMessage from signUpForm.controls.password.errors">{{ errorMessage }}</span>
  </div>

  <mat-checkbox formControlName="termsAccepted">
    <span [innerHTML]="'AUTH.SIGN_UP.TERMS_AND_CONDITIONS' | translate : { dataProcessingUrl: dataProcessingUrl(), privacyPolicyUrl: privacyPolicyUrl(), termsUrl: termsUrl() }"></span>
  </mat-checkbox>

  <mat-checkbox formControlName="marketingConsent">
    {{ 'AUTH.SIGN_UP.MARKETING_CONSENT' | translate }}
  </mat-checkbox>

  <button type="submit">{{ 'AUTH.ACTIONS.SIGN_UP' | translate }}</button>
  <button mat-flat-button [disabled]="!signUpForm.valid" type="button" (click)="signUp()">{{ 'AUTH.ACTIONS.SIGN_UP' | translate }}</button>
</form>

<r2e-sign-in-providers [disabled]="!signUpForm.controls.termsAccepted.value" [marketingConsent]="marketingConsent()" />

<footer>
  <div class="sign-up">
    {{ 'AUTH.SIGN_UP.EXISTING_ACCOUNT_QUESTION' | translate }} <a routerLink="../sign-in">{{ 'AUTH.ACTIONS.SIGN_IN' | translate }}</a>
  </div>
</footer>
